import { useSortBy, useStats } from 'react-instantsearch';
import { useSearchData } from '@/contexts/searchContext';
import * as Styled from './SearchToolbar.styled';

interface SearchToolbarProps {
  onFilterToggle: () => void;
}

export const SearchToolbar = ({
  onFilterToggle,
}: SearchToolbarProps) => {
  const { algolia } = useSearchData();
  const { nbHits, processingTimeMS } = useStats();
  const { currentRefinement, options, refine } = useSortBy({
    items: [
      { value: algolia.productIndex, label: 'Popularity' },
      { value: algolia.productIndexAlphabeticalAsc, label: 'Name A-Z' },
      { value: algolia.productIndexAlphabeticalDesc, label: 'Name Z-A' },
      { value: algolia.productIndexPriceAsc, label: 'Lowest Price' },
      { value: algolia.productIndexPriceDesc, label: 'Highest Price' },
    ],
  });

  return (
    <Styled.Wrapper>
      <Styled.Left>
        <span>{nbHits.toLocaleString()} {nbHits === 1 ? 'result' : 'results'} found in {processingTimeMS}ms</span>
      </Styled.Left>
      <Styled.Right>
        <Styled.FilterButton onClick={onFilterToggle} type="button">
          Filter
        </Styled.FilterButton>
        <Styled.SortWrapper>
          <select
            onChange={e => refine(e.target.value)}
            value={currentRefinement}
          >
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </Styled.SortWrapper>
      </Styled.Right>
    </Styled.Wrapper>
  );
};
